module.exports = __webpack_public_path__ + "static/media/kik_logo.dc93945d.png";